import React from "react";
import { buildPrintDocument } from "./printDocument";

export function PrintButton({
  htmlContent,
  label = "Imprimir",
  title = "Imprimir conteúdo",
}) {
  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    if (!printWindow) return;
    printWindow.document.write(buildPrintDocument(htmlContent));
    printWindow.document.close();
  };

  return (
    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
      <button
        type="button"
        onClick={handlePrint}
        style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "#F8FAFC", border: "1px solid #E2E8F0", color: "#475569",
          padding: "6px 12px", margin: "5px 10px", borderRadius: 8,
          fontSize: 12, fontWeight: 600, cursor: "pointer",
        }}
        title={title}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="6 9 6 2 18 2 18 9" />
          <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
          <rect x="6" y="14" width="12" height="8" />
        </svg>
        {label}
      </button>
    </div>
  );
}
